import React from "react";
const ConfirmationModal = ({ show, onClose, title, body, actions, className}) => {


    return (
        <div className={`modal ${show ? "d-block" : "d-none"} ${className}`} tabIndex="-1">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{title}</h5>
                        <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <p>{body}</p>
                    </div>
                    <div className="modal-footer">
                        {actions && actions.map((action, index) => (
                            <button
                                key={index}
                                type="button"
                                className={`btn ${action.className} me-3`}
                                onClick={action.onClick}
                            >
                                {action.label}
                            </button>
                        ))}
                        <button type="button" className="btn bth-close" onClick={onClose}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ConfirmationModal;


